export default __webpack_public_path__ + "static/media/bol_2.c641b336.svg";